import {get} from "lodash"
import BaseService from "./Base"
import {ListSapCheckpointsPayload, SapCheckpoint, SapCheckpointPayload} from "types/settings/sap-checkpoint"
import {
    ListSapCheckpointChecksPayload,
    SapCheckpointCheck,
    RunSapCheckpointChecksPayload,
    SapCheckpointChecksFilter,
    SapCheckpointChecksStats,
    UpdateSapCheckpointChecksPayload
} from "types/settings/sap-checkpoint-check"

class SapCheckpointsService extends BaseService {
    async list(params: ListSapCheckpointsPayload = {}): Promise<{data: SapCheckpoint[]; total: number}> {
        const response = await this.post("/v1/sap-checkpoints/list", params)
        const result = get(response, "data", {})
        return {
            data: get(result, "data", []),
            total: get(result, "total", 0)
        }
    }

    async getOne(sapCheckpointId: number): Promise<SapCheckpoint> {
        const response = await this.post("/v1/sap-checkpoints/get", {sapCheckpointId})
        return get(response, "data.data", {})
    }

    async create(data: SapCheckpointPayload): Promise<SapCheckpoint> {
        const response = await this.post("/v1/sap-checkpoints/create", data)
        return get(response, "data.data", {})
    }

    async update(sapCheckpointId: number, data: SapCheckpointPayload): Promise<SapCheckpoint> {
        const response = await this.post("/v1/sap-checkpoints/update", {sapCheckpointId, ...data})
        return get(response, "data.data", {})
    }

    async deleteBulk(sapCheckpointIds: number[]): Promise<void> {
        await this.post("/v1/sap-checkpoints/delete", {sapCheckpointIds})
    }

    async listChecks(
        params: ListSapCheckpointChecksPayload = {}
    ): Promise<{data: SapCheckpointCheck[]; total: number}> {
        const response = await this.post("/v1/sap-checkpoint-checks/list", params)
        const result = get(response, "data", {})
        return {
            data: get(result, "data", []),
            total: get(result, "total", 0)
        }
    }

    async updateChecks(payload: UpdateSapCheckpointChecksPayload, params = {}): Promise<void> {
        await this.post("/v1/sap-checkpoint-checks/update", payload, params)
    }

    async rerunCheck(sapCheckpointCheckId: number): Promise<SapCheckpointCheck> {
        const response = await this.post("/v1/sap-checkpoint-checks/rerun", {sapCheckpointCheckId})
        return get(response, "data.data", {})
    }

    async reviewCheck(payload: {
        sapCheckpointCheckId: number
        approvalStatus: "approved" | "rejected"
    }): Promise<SapCheckpointCheck> {
        const response = await this.post("/v1/sap-checkpoint-checks/review", payload)
        return get(response, "data.data", {})
    }

    async getChecksStats(filter?: SapCheckpointChecksFilter): Promise<SapCheckpointChecksStats> {
        const response = await this.post("/v1/sap-checkpoint-checks/stats", {filter})
        return get(response, "data.data", {studentsHitThisMonth: 0})
    }

    async runChecks(params: RunSapCheckpointChecksPayload = {}): Promise<{created: number}> {
        const response = await this.post("/v1/sap-checkpoint-checks/run", params)
        return get(response, "data.data", {created: 0})
    }
}

export default SapCheckpointsService
